import NetworkingClient from "./networkingClient";

const apiClient = new NetworkingClient(new URL(process.env.BASE_URL!));

export default apiClient;
